import { render, staticRenderFns } from "./Realinhamento.vue?vue&type=template&id=86de7a5a"
import script from "./Realinhamento.vue?vue&type=script&lang=js"
export * from "./Realinhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports